import UITour from 'ui-shepherd-react/tour/UITour';
import MultiTourHandlerSingleton from 'ui-shepherd-react/lib/MultiTourHandlerSingleton';
import { ONBOARDING_TOUR_ID } from '../constants/OnboardingConstants';
import { useOnboardingSteps } from '../hooks/useOnboardingSteps';
import { useInitOnboardingTour } from '../hooks/useInitOnboardingTour';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSpan = styled.span.withConfig({
  displayName: "OnboardingTour__StyledSpan",
  componentId: "mjkjw9-0"
})(["> [data-onboarding='onboarding-tour-container']{height:100% !important;}"]);

/**
 * useInitOnboardingTour requires access to the Tour Context which is provided
 * through the UITour component. So we must render this hook in a component
 * rendered within UITour.
 */
/* eslint-disable-next-line react/display-name */
const RegisterOnboardingTour = () => {
  useInitOnboardingTour();
  return null;
};
const OnboardingTour = ({
  children,
  shouldInitialize = true
}) => {
  const {
    hasUserSeenOnboarding,
    unseenSteps
  } = useOnboardingSteps();

  /**
   * This check is required because the config for UITour is initialized
   * right when the UITour component is rendered and cannot be reset. So we cannot
   * render UITour until config is ready to be used. This check ensures we only
   * render the UITour once the steps have been fetched and the user has not
   * seen all the onboarding steps already.
   *
   * If this were removed UITour would initialize its config to steps: [] and would
   * not render any steps.
   */
  if (hasUserSeenOnboarding) {
    return children;
  }
  return /*#__PURE__*/_jsx(StyledSpan, {
    "data-test-id": "onboarding-tour",
    children: /*#__PURE__*/_jsxs(UITour, {
      config: {
        steps: unseenSteps
      },
      multiTourHandler: MultiTourHandlerSingleton.getInstance(),
      tour: ONBOARDING_TOUR_ID,
      dataOnboarding: "onboarding-tour-container",
      children: [shouldInitialize && /*#__PURE__*/_jsx(RegisterOnboardingTour, {}), children]
    })
  });
};
OnboardingTour.displayName = 'OnboardingTour';
export default OnboardingTour;